import React, { Component } from 'react'

import "../../node_modules/video-react/dist/video-react.css"; // import css
import '../styles/style.css'
import wyt from '../images/wyt.svg'
import {  Player,
    ControlBar,
    ReplayControl,
    ForwardControl,
    CurrentTimeDisplay,
    TimeDivider,
    VolumeMenuButton} from 'video-react';

export default class VideoPage extends Component {
   
    constructor(props)
    {
        super(props);
        this.state={
            videoUrl: '',
            videoTitle: '',
            videoDescription: '',
            videoDate: '',
            video:null
        }

        var video = this.props.location.state.video;
        var vidVideo = video.video;
        video = {video, vidVideo};
        
        var videoDetails = this.props.location.state.video;
        var videoPart = videoDetails.video;
        var video = {...videoDetails,...videoPart};
        this.list={
            content: "Anika Rabbani",
            creationDate: "2020-10-21 15:25:49",
            description: "Anika Rabbani'r ekti Live Session e aamontron",
            heartCount: "",
            language: "English",
            likesCount: "",
            previewImage: "http://223.30.211.125:8080/bcms/downloadAPI.do?params=60SRPFdwbrqrF%2FI23AAJBogM6WbF2zJWO8n%2BmX2RUBM1zLwoO8fwwQB5b3sUrXxVIbFO09czmbXt%0AE1HaUWOEOeMh6Xuc2QwfEj1nXQ8bmQswY6A1yzYacf24g%2F38d9B5awYzXJyYIvINActrrGHY7gkM%0Ayni2TXHLa1KurfjnVrAHv5KVg8NJI1qw8ZCD9YatE30zT8euY2xUHsoelkvs%2FehnxGOAiVyEg3kA%0AAiZxyMZ5ZvY0NZWbH7avYPXOe%2B6mItveuHj2meHo1q3L9f6yqTZqmh2BuO4PWSnhvu%2FYCCwG3IK5%0AQGp5qcp2Kp59Aur05p8Ve13onEDYf3MOcSWWL9EGP4%2FEn0Bk%2BKFAgWX2Z4g%3D",
            releaseYear: "-00:34",
            title: "Anika Rabbani",
            validTo: "2040-10-21 15:25:49",
            validfrom: "2020-10-21 15:25:49",
            duration: "00:34",
            encoding: "mp4",
            feed: "http://223.30.211.125:8080/bcms/downloadAPI.do?params=60SRPFdwbrqrF%2FI23AAJBogM6WbF2zJWO8n%2BmX2RUBM1zLwoO8fwwQB5b3sUrXxVIbFO09czmbXt%0AE1HaUWOEOeMh6Xuc2QwfEj1nXQ8bmQswY6A1yzYacf24g%2F38d9B5awYzXJyYIvINActrrGHY7gkM%0Ayni2TXHLa1KurfjnVrAHv5KVg8NJI1qw8ZCD9YatE30zT8euY2xUHsoelkvs%2FehnxGOAiVyEg3kA%0AAiZxyMZ5ZvY0NZWbH7avYPXOe%2B6mItveuHj2meHo1q3L9f6yqTZqmh2BuO4PWSnhvu%2FYCCwG3IK5%0AQGp5qcp2Kp59Aur0zcN%2FD7VvdKCXBOoQclFKB6wPBrDJ7Nili%2BVZgq4o0TFTIdh2OiYyU0digkxZ%0AgFxG",
            filepathurl: "http://223.30.211.125:8080/bcms/downloadAPI.do?params=60SRPFdwbrqrF%2FI23AAJBogM6WbF2zJWO8n%2BmX2RUBM1zLwoO8fwwQB5b3sUrXxVIbFO09czmbXt%0AE1HaUWOEOeMh6Xuc2QwfEj1nXQ8bmQswY6A1yzYacf24g%2F38d9B5awYzXJyYIvINActrrGHY7gkM%0Ayni2TXHLa1KurfjnVrAHv5KVg8NJI1qw8ZCD9YatE30zT8euY2xUHsoelkvs%2FehnxGOAiVyEg3kA%0AAiZxyMZ5ZvY0NZWbH7avYPXOe%2B6mItveuHj2meHo1q3L9f6yqTZqmh2BuO4PWSnhvu%2FYCCwG3IK5%0AQGp5qcp2Kp59Aur0zcN%2FD7VvdKCXBOoQclFKB6wPBrDJ7Nili%2BVZgq4o0TFTIdh2OiYyU0digkxZ%0AgFxG",
            hd: "no",
            resolution: "720x480",
            videoLength: "00:34",
            viewCount: "3.2k"
            };
            
            this.list=video;
            console.log("video to play",this.list);
            //debugger;
            
            this.videoRef=React.createRef();
            this.skip = this.skip.bind(this);
    }

    componentDidMount()
    {
        //debugger;
        this.setState({
            ...this.state,
            video: this.videoRef.current
          });
        
          this.setState({
            videoUrl: this.list.filepathurl,
            videoTitle: this.list.content,
            videoDescription: this.list.description
        });
        setTimeout(()=>{this.videoRef.current.actions.toggleFullscreen();this.videoRef.current.actions.play();},500);
        console.log("this.videoRef",this.videoRef);
          
    }
    skip(e) {
        const skipValue = e.target.attributes[0].value;
        if (!isNaN(skipValue)) {
         this.videoRef.current.currentTime += Number(skipValue);
        }
      }
    playVideo(list) {
    //    $("html, body").animate({ scrollTop: 0 }, "fast");
   
        this.setState({
            videoUrl: this.list.filepathurl,
            videoTitle: this.list.content,
            videoDescription: this.list.description
        });
    }

    render() {
    //if(this.state.videoUrl)
    return(
        <div className="bg-color-player">
            <div className="player-head">
                <span><img src={wyt} onClick={()=>{this.props.history.goBack()}}></img></span>
                <span>{this.state.videoTitle}</span>
            </div>
          <Player
          ref={this.videoRef}
          playsInline
          autoPlay
          poster="/assets/poster.png"
          src={this.state.videoUrl}>

           <ControlBar>
        <ReplayControl seconds={10} order={1.1} />
        <ForwardControl seconds={10} order={1.2} />
        <CurrentTimeDisplay order={4.1} />
        <TimeDivider order={4.2} />
        <VolumeMenuButton disabled />
      </ControlBar>

      </Player>
      
        </div>
    )
        
        // return (
        //     <div className="live-video-item" onClick={() => this.playVideo(this.list)}>
        //             <div className="live-video-item-left">
        //                 <img src={this.list.previewImage}></img>
        //                 <p>{this.list.videoLength}</p>
        //             </div>
        //             <div className="live-video-item-right">
        //                 <p>{this.list.content}</p>
        //                 <p>  {this.list.description.length > 80 ?
        //                     this.list.description.substring(0, 80) + '...' :
        //                     this.list.description
        //                 }</p>
        //                 {/*<p>
        //                     <span><img src={clock}></img></span>
        //                     <span>{getFormattedDate(list.creationDate)}</span>
        //                 </p>
        //                 */}
        //             </div>
        //         </div>
        // )
    }
}
